<div class="grid">

  <app-tile-button fitHeight dictionaryKey="tmc-yard.ui.admin.yard-administration.action.reload-yard-clients" iconCSS="fa-clock"
    (click)="triggerYardClientsReload()">
  </app-tile-button>

  <app-tile-button fitHeight dictionaryKey="tmc-yard.ui.admin.yard-administration.action.create-emergency-printout"
    iconCSS="fa-siren-on" (click)="createEmergencyPrintout()">
  </app-tile-button>

  <app-tile-button fitHeight dictionaryKey="tmc-yard.ui.admin.yard-administration.action.export-configuration"
    iconCSS="fa-file-export" (click)="exportConfiguration()">
  </app-tile-button>

  <app-tile-button fitHeight dictionaryKey="tmc-yard.ui.admin.yard-administration.action.clean-transports" iconCSS="fa-broom"
    (click)="cleanTransports()">
  </app-tile-button>

</div>

<app-service-response [responseMessages]="responseMessages"></app-service-response>
